/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectivity_History_Offline_TimeInputs */



/**
* | output |
* | --- |
* | "Time offline" |
*
* @param {Connectivity_History_Offline_TimeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_offline_time = /** @type {((inputs?: Connectivity_History_Offline_TimeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_Offline_TimeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Time offline")
	return /** @type {LocalizedString} */ ("Temps hors ligne")
});